import {UcoastEl} from "@/scripts/core/UcoastEl";
import { qsRequired, targetClosestRequired } from '@/scripts/core/global'

export class ShowMoreButton extends UcoastEl {
	static htmlSelector = 'show-more-button'
	constructor() {

		super();
		const button = qsRequired('button', this);
		button.addEventListener('click', (event) => {
			this.expandShowMore(event);
			const closestDisplay = targetClosestRequired(event, '.parent-display');
			const nextElementToFocus = closestDisplay.querySelector('.show-more-item');
			if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
				nextElementToFocus.querySelector('input')?.focus();
			}
		});
	}
	expandShowMore(event: Event) {
		const closestShowMore = targetClosestRequired(event, '[id^="Show-More-"]');
		const parentDisplay = closestShowMore.closest('.parent-display');
		//const parentWrap = parentDisplay?.querySelector('.parent-wrap');
		this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
		parentDisplay?.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
	}
}
